import CardLink from "components/molecules/CardLink";
import Carousel from "components/molecules/Carousel";
import CarouselItem from "components/molecules/Carousel/CarouselItem";
import FrameImage from "components/molecules/FrameImage";
import { BASE_URL } from "constants/env";
import React, { useMemo } from "react";
import { SwiperOptions } from "swiper";
import { SwiperSlide } from "swiper/react";
import "./index.scss";
interface GroupCardLinkProps {
  services: ServicesHomepage;
}

const GroupCardLink: React.FC<GroupCardLinkProps> = ({
  services,
}: GroupCardLinkProps) => {
  const items = useMemo(() => services && Object.values(services.items), [
    services,
  ]);
  const breakpoints = {
    320: {
      slidesPerView: 1.2,
    },
    480: {
      slidesPerView: 1.3,
    },
    576: {
      slidesPerView: 2.2,
    },
    768: {
      slidesPerView: 2.3,
    },
    992: {
      slidesPerView: 3.2,
    },
  };
  const options = {
    loop: true,
    speed: 500,
    spaceBetween: 10,
    breakpoints,
    autoplay: true,
    centeredSlides: true,
    shouldSwiperUpdate: true,
    pagination: false,
    rebuildOnUpdate: true,
  } as SwiperOptions;
  return (
    <div className="o-groupcardlink">
      <div className="o-groupcardlink_desktop">
        <div className="m-carousel">
          <Carousel
            customParams={options}
          >
            {items.map(item => (
              <SwiperSlide key={item.image}>
                <CarouselItem>
                  <CardLink
                    image={
                      <FrameImage
                        src={`${BASE_URL}${item.image}`}
                        ratio={0.6676527331} // 207.64 / 311
                        zoom
                        mask
                      />
                    }
                    label={item.text}
                    href={item.link}
                  />
                </CarouselItem>
              </SwiperSlide>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

GroupCardLink.defaultProps = {};

export default GroupCardLink;
